import {useEffect, useState} from "react";
import {FaArrowDown} from "react-icons/fa"
import DetailsBookingList from "./DetailsBookingList";
import {IBooking} from "../../utils/interfaces/IBooking";
import {motion} from "framer-motion";

interface BookingsProps {
    obj: IBooking,
}

function Bookings({obj: initialObj}: BookingsProps) {
    const [obj, setObj] = useState<IBooking>(initialObj)
    const [openDetails, setOpenDetails] = useState<boolean>(false)

    let labelStyle = 'text-sm text-gray-500 font-bold mr-1 cursor-pointer ';
    let contentStyle = 'text-sm text-gray-800 font-bold mr-1 cursor-pointer ';

    useEffect(() => {
        if (initialObj) {
            setObj(initialObj)
        }
    }, [initialObj])

    return (
        <>
            <motion.div
                className="bg-mcia_gray_soft shadow-xl rounded-lg p-4 mb-4 w-[800px] relative"
                initial={{x: '150%'}}
                animate={{x: '0%'}}
                transition={{duration: 0.2}}
            >
                <div className="grid grid-cols-2 gap-2">
                    <div>
                        <h2 className={labelStyle}>Prenotazioni:</h2>
                    </div>
                    <div>
                        <div className="flex flex-row">
                            <label className={labelStyle}>Count: </label>
                            <label className={contentStyle}>{obj.totals.count}</label>
                        </div>
                        <div className="flex flex-row">
                            <label className={labelStyle}>Total Seats: </label>
                            <label className={contentStyle}>{obj.totals.seats}</label>
                        </div>

                        <div className="flex flex-row">
                            <label className={labelStyle}>Total Net Amount: </label>
                            <label className={contentStyle}>{obj.totals.nett_price.toFixed(2) + ' €'}</label>
                        </div>
                        <div className="flex flex-row">
                            <label className={labelStyle}>Total Vat Amount: </label>
                            <label className={contentStyle}>{obj.totals.vat.toFixed(2) + ' €'}</label>
                        </div>
                        <div className="flex flex-row">
                            <label className={labelStyle}>Total Gross Amount: </label>
                            <label className={contentStyle}>{obj.totals.gross_price.toFixed(2) + ' €'}</label>
                        </div>
                    </div>
                </div>

                {obj.details.length > 0 ?
                    <button
                        className="cisco_totals_div mb-0.5 w-[200px] absolute bottom-2 left-2 flex items-center justify-between shadow-xl"
                        onClick={() => setOpenDetails(!openDetails)}
                    >
                        {openDetails ? <span>Close Details</span> : <span>Open Details</span>}
                        <span className="mr-2">
                        <FaArrowDown
                            className={openDetails ? 'rotate-180 duration-300' : 'rotate-0 duration-300'}/>
                    </span>
                    </button>
                    :
                    ''}

            </motion.div>

            {openDetails ? <DetailsBookingList obj={obj}/> : ''}
        </>

    )
}

export default Bookings;